<template>
	<BaseLayout background-color-class="bg-color-white" :content-full-height="true" :footer-full="true">
		<div class="container">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md">
					<BasePlaceHolderInline width="4em" :placehold="loading">
						<HelpCenterHeader v-if="category" :category="category" class="mb-50" />
					</BasePlaceHolderInline>
					<BasePlaceHolder :class="{ 'mt-200': loading }" :line-count="5" :placehold="loading">
						<div v-if="category">
							<h1 class="heading-2">{{ category.name }}</h1>
							<p class="delta-md">{{ category.description }}</p>
							<HelpCenterList
								v-for="section in category.sections"
								:key="section.id"
								:max-length="6"
								:section="section"
							/>
						</div>
					</BasePlaceHolder>
				</div>
			</div>
		</div>
	</BaseLayout>
</template>

<script setup lang="ts">
import { computed, Ref, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getHelpCenterCategory } from '@api/help-center';
import { HelpCenterCategory } from 'types/help-center';
import HelpCenterHeader from '@components/help-center/help-center-header.vue';
import HelpCenterList from '@components/help-center/help-center-list.vue';
import { useHead } from '@unhead/vue';
import { useMixpanel } from '@utils/composables/use-mixpanel';

const loading = ref(true);
const category: Ref<HelpCenterCategory | null> = ref(null);

const route = useRoute();
const router = useRouter();

const categoryId = computed((): string => route.params.categoryId as string);

const { trackMixpanelView } = useMixpanel();
async function setup(): Promise<void> {
	useHead({
		title: 'Help Center',
		meta: [{ property: 'og:title', content: 'Help Center' }]
	});
	try {
		category.value = await getHelpCenterCategory(categoryId.value);
		loading.value = false;
		trackMixpanelView('Page', { 'View Title': category.value.name });
	} catch {
		await router.push({ name: 'help-center-landing' });
	}
}
setup();
</script>
